import axios from "axios";
import { FeatureCollection, GeoJsonProperties, Geometry } from "geojson";

export interface WMSFeatureInfoParams {
  x: number;
  y: number;
  width: number;
  height: number;
  bbox: string;
  layers: string;
  query_layers: string;
  buffer?: number;
  version?: string;
  request?: string;
  service?: string;
  srs?: string;
  info_format?: string;
  viewParams?: string;
}

export async function getWMSFeatureInfo<P>(
  customParams: WMSFeatureInfoParams
): Promise<FeatureCollection<Geometry, P & GeoJsonProperties>> {
  const defaultParams: Partial<WMSFeatureInfoParams> = {
    version: "1.1.1",
    request: "GetFeatureInfo",
    service: "WMS",
    srs: "EPSG:4326",
    buffer: 5,
    info_format: "application/json",
  };
  const config = {
    params: { ...defaultParams, ...customParams },
  };

  try {
    const { data } = await axios.get(`/geoserver/wms`, config);
    return data;
  } catch (ex) {
    console.error(ex);
    throw ex;
  }
}

export interface WFSGetFeatureParams {
  typeNames?: string;
  cql_filter?: string;
  viewParams?: string;
  featureCount?: number;
  request?: string;
  service?: string;
  version?: string;
  outputFormat?: string;
  srsName?: string;
}

export async function getWFSGetFeature<P>(
  customParams: WFSGetFeatureParams
): Promise<FeatureCollection<Geometry, P & GeoJsonProperties>> {
  const defaultParams: Partial<WFSGetFeatureParams> = {
    typeNames: "",
    cql_filter: "",
    viewParams: "",
    featureCount: 100,
    request: "GetFeature",
    service: "WFS",
    version: "2.0",
    outputFormat: "application/json",
    srsName: "EPSG:4326",
  };
  const config = {
    params: { ...defaultParams, ...customParams },
  };

  try {
    const { data } = await axios.get(`/geoserver/wfs`, config);
    return data;
  } catch (ex) {
    console.error(ex);
    throw ex;
  }
}
